import React from "react";
import { Separator, Text } from "@showitinc/showit-wc";
import ButtonBar from "../SetupButtonBar";
import ViewPanel from "../ViewPanel";

function UpdateStart({ blogSetup, actions }) {
  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Blog Set Up In Progress
            </Text>
            <Separator />
            <div>
              <Text>
                We are currently setting up your Showit Blog.
                <br />
                We will contact you when it is ready to go.
              </Text>
              <Text>
                If you need to update information related to your blog, please contact the Showit
                support team.
              </Text>
            </div>
          </>
        ),
        actions: (
          <ButtonBar
            onForward={() => {
              actions.goToNextStep();
            }}
            allowForward
            forwardBtnText="Next"
          />
        ),
      }}
    </ViewPanel>
  );
}

export default UpdateStart;
